// extracted by mini-css-extract-plugin
export default {"hapax-counts-container":"HapaxCountsAnalysis_hapax-counts-container__Ya7Ye","hapax-counts-wrapper":"HapaxCountsAnalysis_hapax-counts-wrapper__XXpgy"};